//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/ToolDesigner.js";
import "../no/Builder.js";
import "../no/ugmath.js";
let d=[[[0,"CurrentSectionAngle",0,0]],[[["radius"],"SetRadius",{},1,0],[["center"],"SetCenter",{},1,0],[["axisVec"],"SetAxis1",{},1,0],[["axisVec"],"SetAxis2",{},1,0],[["sections","colors"],"SetPieSections",{},2,0],[[],"ResetInitData",{},0,0],[[],"JumpToPrevSection",{R_:{targetIndex:''}},0,0],[[],"JumpToNextSection",{R_:{targetIndex:''}},0,0]],[]];
SPLM.ToolDesigner.ReusePieChartBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.ToolDesigner.ReusePieChartBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;